import React, { Component, useEffect, useState } from "react";
import styled from "styled-components";
import {
  NewBackButton,
} from "../../../components/svgs";
import {
  StyledText,
  DynamicButton,
  MainHolder,
  Children,
  Body
} from "../../../components/common/basic";

import { logEvent } from "firebase/analytics";
import analytics from "../../../context/analytics";
import { AlertModal, BackButton, FullScreenSelect, QuantityControl } from "../../../components/common";
import MashupRedemptionStatus from "./components/MashupRedemptionStatus";
import RewardItemCard from "./components/RewardItemCard";
import useMashupNWinPickup from "./hooks/useMashupnWinPickup";

const MashupnWinPickup = () => {
  useEffect(() => {
    analytics().then(anl => logEvent(anl, "screen_view", {
      firebase_screen: "MashupAndWinPickup",
      firebase_screen_class: "MashupAndWinPickup",
    }));
  }, []);

  const {
    background,
    history,
    regionFmt,
    image,
    name,
    amount,
    showAlert,
    setShowAlert,
    quantity,
    setQuantity,
    region,
    setRegion,
    officeLocation,
    setOfficeLocation,
    officeLocations,
    isValidQuantity,
    handleSubmit,
    unitPoints,
    updatedUserPoints,
  } = useMashupNWinPickup();

  return (
    <>
      <MainHolder>
        <BackButton onClick={() => {
          history.goBack();
        }} />
        <Children>
          <Header>
            <div style={{ textAlign: 'center' }}>
              <StyledText size={24} style={{ fontFamily: 'MTNMedium' }} margin="0">{'Mashup & Win'}</StyledText>
            </div>
          </Header>
          <Body>
            {
              // TODO: Update success property
              showAlert &&
              <AlertModal
                background={background}
                success={true}
                onClick={() => { setShowAlert(false) }} >
                <MashupRedemptionStatus background={background} history={history} />
              </AlertModal>
            }
            <div style={{ boxSizing: 'border-box', padding: '0 15px' }}>
              <RewardItemCard
                color={background}
                image={image}
                points={amount * unitPoints}
                name={name}
              />
              <hr style={{ margin: '15px 0', borderTop: 'none', borderBottom: '1px solid #ddd' }} />

              <QuantityControl title="Quantity to Redeem" value={quantity} setValue={setQuantity} iconBackground={background} />

              <div style={{ marginBottom: '150px' }}>
                <StyledText size={18} style={{ fontFamily: 'MTNRegular' }}>Pickup from MTN Office </StyledText>
                <FullScreenSelect
                  placeholder="Region"
                  data={regionFmt}
                  selected={region}
                  setValue={setRegion}
                  activeColor={background} />
                <FullScreenSelect
                  placeholder="MTN Office"
                  data={officeLocations}
                  selected={officeLocation}
                  setValue={setOfficeLocation}
                  activeColor={background} />
              </div>

              <div style={{ position: 'absolute', bottom: 0, left: 0, width: '100%', background: '#fff', borderTop: '1px solid #ddd' }}>
                <div style={{ padding: '10px' }}>
                  {updatedUserPoints < 0 && <StyledText color="red" style={{ textAlign: 'center', margin: 0 }} >You do not have enough points to redeem</StyledText>}
                </div>
                <div style={{ padding: '10px 30px' }}>
                  <DynamicButton
                    onClick={handleSubmit}
                    label={"Redeem"}
                    disabled={!isValidQuantity || !region || updatedUserPoints < 0 || !officeLocation}
                    color={background}
                    fullWidth
                  />
                </div>
              </div>
            </div>
          </Body>
        </Children>
      </MainHolder>
    </>
  );
};

const Header = styled.div`
  /* width: 360px; */
  overflow: hidden;
  padding: 20px 20px 10px 20px;
  background-color: ${({ background }) => background};
  position: relative;
`;

export default MashupnWinPickup;
